import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './Narrative.css';

/**
 * Catch-all page for unknown URLs.
 *
 * Flask serves this shell with a real HTTP 404 status for any path that is not a
 * known client route (see SPA_ROUTES in app.py), and the SEO component marks it
 * `noindex, follow`. Together that avoids a soft 404: crawlers get a genuine 404
 * status instead of a valid-looking, empty page.
 */
function NotFound() {
  return (
    <div className="np-page">
      <SEO
        title="Page not found — 404 | Codentic AI"
        description="That page does not exist or has been retired. Browse the memory side-car, our products, or the published research instead."
        robots="noindex, follow"
      />

      <section className="np-hero np-hero--compact">
        <div className="container">
          <span className="np-eyebrow">Error 404</span>
          <h1>That page does not exist</h1>
          <p className="np-hero-sub">
            The address may be out of date, or the page may have been retired. Everything we
            publish is reachable from the links below.
          </p>
        </div>
      </section>

      <section className="np-section">
        <div className="container">
          <div className="np-grid np-grid--3">
            <div className="np-card">
              <h3 className="np-h3">How the side-car works</h3>
              <p className="np-body">
                The EWM loop: encodings in, content-addressed state, ordered materialize,
                encodings back to the host.
              </p>
            </div>
            <div className="np-card">
              <h3 className="np-h3">Products</h3>
              <p className="np-body">
                NanoLM, the AI Enterprise Suite and the vertical packs built on the same
                structural memory layer.
              </p>
            </div>
            <div className="np-card">
              <h3 className="np-h3">Docs &amp; Research</h3>
              <p className="np-body">
                The published record and the framework paper, readable in the browser.
              </p>
            </div>
          </div>

          <div className="np-cta-row np-cta-row--center">
            <Link to="/technology" className="np-btn np-btn--primary">How It Works</Link>
            <Link to="/products" className="np-btn np-btn--secondary">See Products</Link>
            <Link to="/publications" className="np-btn np-btn--secondary">Docs &amp; Research</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default NotFound;
